
import TableCellPropertyCommand from './tablecellpropertycommand';

export default class TableCellHorizontalAlignmentCommand extends TableCellPropertyCommand {
    /**
     * Creates a new `TableCellHorizontalAlignmentCommand` instance.
     *
     * @param editor An editor in which this command will be used.
     * @param defaultValue The default value for the "alignment" attribute.
     */
    constructor(editor, defaultValue) {
        super(editor, 'tableCellHorizontalAlignment', defaultValue);
    }
}
